import { render, staticRenderFns } from "./HeaderLoginAndReg.vue?vue&type=template&id=b31696fa"
import script from "./HeaderLoginAndReg.vue?vue&type=script&lang=js"
export * from "./HeaderLoginAndReg.vue?vue&type=script&lang=js"
import style0 from "./HeaderLoginAndReg.vue?vue&type=style&index=0&id=b31696fa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports